import { useQuery } from '@tanstack/react-query';
import type { ISearchFilterIdItemDto } from '~/dtos/hub/hub.models.generated';
import { clientFetch } from '~/common/utils/clientFetch.client';

export function useFilterItemsQuery(
  key: string,
  area: string,
  fetchUrl: string,
  enabled: boolean = true
) {
  return useQuery({
    queryKey: ['filters', area, key, fetchUrl],
    queryFn: async () => {
      const res = await clientFetch(fetchUrl);
      const data = await res.json();
      return data.filterItems as ISearchFilterIdItemDto[];
    },
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
    enabled
  });
}
